import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/guard-tours")({
  component: () => <Outlet />,
});
